import type { SVGProps } from "react";
export interface ShopIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShopIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShopIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.875 18a1.875 1.875 0 1 0-3.75 0v1.875h3.75zm2.25 1.875H18c1.036 0 1.875-.84 1.875-1.875V9.632a1.125 1.125 0 0 1 2.25 0V18A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V9.685a1.125 1.125 0 0 1 2.25 0V18c0 1.036.84 1.875 1.875 1.875h1.875V18a4.125 4.125 0 1 1 8.25 0z"
      />
      <path
        fill={color}
        d="M19.82 1.875c.861 0 1.63.52 1.959 1.304l.06.16 1.098 3.357.088.304c.068.276.117.603.087.957l-.028.215c-.363 2.042-2.276 3.453-4.407 3.453-1.287 0-2.503-.524-3.34-1.389-.838.865-2.052 1.389-3.34 1.389s-2.503-.524-3.34-1.389c-.838.865-2.053 1.389-3.34 1.389-1.99 0-3.788-1.23-4.313-3.054l-.088-.372c-.111-.604.027-1.152.157-1.532l1.141-3.352.062-.158a2.13 2.13 0 0 1 1.95-1.282zM3.203 7.393c-.082.242-.083.353-.075.397l.037.152c.221.757 1.034 1.433 2.152 1.433 1.34 0 2.216-.95 2.216-1.875a1.125 1.125 0 0 1 2.244-.116l.015.289c.1.867.95 1.702 2.206 1.702 1.34 0 2.215-.95 2.215-1.875a1.125 1.125 0 0 1 2.244-.116l.006.116.01.173c.1.867.948 1.702 2.204 1.702 1.198 0 2.045-.776 2.19-1.595l-.003-.12a1 1 0 0 0-.02-.112l-.045-.153-1.071-3.27H4.315z"
      />
    </svg>
  );
}
